<template>
  <div id="app">
    <Navbar />

    <!-- Searchbar -->
    <b-modal
      v-model="isSearchbarOpen"
      has-modal-card
      full-screen
      class="searchbar-modal"
      style="justify-content: start; z-index: 1200"
      @after-enter="focusSearchInput"
    >
      <template #default>
        <div class="modal-card">
          <section
            class="modal-card-body is-flex is-justify-content-center"
            style="
              height: 100%;
              background-color: transparent;
              overflow: hidden;
              padding-bottom: 40px;
              padding-top: 54px;
            "
          >
            <SearchBar
              ref="searchBar"
              hideCloseBtn
              inline
              style="width: 540px"
              tooltipPos="is-top"
            />
          </section>
        </div>
      </template>
    </b-modal>
    <!-- End of Searchbar -->

    <div v-if="lockAccess">
      <Problem />
    </div>
    <div v-else>
      <router-view />
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import Navbar from "./components/Navbar.vue";
import Problem from "./views/Problem.vue";

export default {
  data() {
    return {
      // INFO: set to true if the login should be blocked
      lockAccess: false
    };
  },
  components: {
    Navbar,
    Problem,
    SearchBar
  },
  metaInfo: {
    title: "Standortmonitor | GOLDMEDIA"
    // titleTemplate: '%s | Standortmonitor.net',
  },
  computed: {
    isSearchbarOpen: {
      get() {
        return this.$store.state.searchBarOpen;
      },
      set() {
        this.$store.commit("TOGGLE_SEARCH_BAR");
      }
    }
  },
  methods: {
    focusSearchInput() {
      this.$refs.searchBar.focus();
    }
  },
  created() {
    if (!this.lockAccess) {
      this.$store.dispatch("auth/PRE_LOGIN");
    }
  }
};
</script>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

.searchbar-modal.modal.is-full-screen > .animation-content,
.searchbar-modal.modal.is-full-screen > .animation-content > .modal-card {
  background-color: transparent;
}

.set-height {
  height: 65px;
}

.b-tooltips {
  .b-tooltip:not(:last-child) {
    margin-right: 0.5em;
  }
  .b-tooltip {
    margin-bottom: 0.5em;
  }
}

@include mobile {
  .b-table .table-wrapper.has-mobile-cards tr .checkbox-cell {
    padding-right: 0;
  }
  .b-table
    .table-wrapper.has-mobile-cards
    tr
    .checkbox-cell
    .b-checkbox.checkbox:not(.button) {
    margin-right: 0;
  }
}

// Set custom font
$family-sans-serif: "Arial";
$family-primary: $family-sans-serif;

// Set your colors
$gold: #ac8856;
$gold-light: findLightColor($gold);
$gold-dark: findDarkColor($gold);
$gold-invert: findColorInvert($gold);

$grey: #455a64;
$grey-light: findLightColor($grey);
$grey-dark: findDarkColor($grey);
$grey-invert: findColorInvert($grey);

$grey-1: #9fb0c0;
$grey-1-light: findLightColor($grey-1);
$grey-1-dark: findDarkColor($grey-1);
$grey-1-invert: findColorInvert($grey-1);

$grey-2: #556e89;
$grey-2-light: findLightColor($grey-2);
$grey-2-dark: findDarkColor($grey-2);
$grey-2-invert: findColorInvert($grey-2);

$off-grey: #4c4c4c;
$off-grey-light: findLightColor($off-grey);
$off-grey-dark: findDarkColor($off-grey);
$off-grey-invert: findColorInvert($off-grey);

$primary: $grey;
$primary-light: findLightColor($primary);
$primary-dark: findDarkColor($primary);
$primary-invert: findColorInvert($primary);

// text
$text: $grey;
$text-strong: $off-grey;

// links
$link: $gold;
$link-invert: $gold-invert;
$link-focus-border: $gold;

// Set custom components
// general
// $radius: 0px;
// $radius-small: 0px;
// $radius-large: 0px;
// $control-radius: $radius;

// navbar
$navbar-height: 1.5rem;
$navbar-padding-vertical: 0.5rem;
$navbar-item-img-max-height: 1rem;
$navbar-background-color: $gold;
$navbar-item-color: $grey;
$navbar-item-active-color: $white;
$navbar-item-hover-color: $white;
$navbar-item-active-background-color: $gold;
$navbar-item-hover-background-color: $off-grey;
// $navbar-item-hover-color: $grey-dark;
// $navbar-dropdown-arrow: $navbar-item-color;
// $navbar-dropdown-item-color: $grey;
// $navbar-dropdown-item-hover-color: $grey-dark;
// $navbar-item-hover-background-color: $scheme-main-bis;

// card
$card-header-background-color: $gold;
$card-header-color: $white;

// // Lists and maps
// $custom-colors: null !default;
// $custom-shades: null !default;

// input
// $input-border-color: rgb(172, 136, 86);
// $input-hover-border-color: #a48151;
// $input-focus-border-color: #9c7b4d;

// buttons
// $button-color: $white;
// $button-color-hover: $off-grey;
// $button-background-color: $gold;
// $button-border-color: $white;
// $button-border-color-hover: $off-grey;
// $button-border-width: 1px;

// // Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: mergeColorMaps(
  (
    "white": (
      $white,
      $black,
    ),
    "black": (
      $black,
      $white,
    ),
    "light": (
      $light,
      $light-invert,
    ),
    "dark": (
      $dark,
      $dark-invert,
    ),
    "primary": (
      $primary,
      $primary-invert,
      $primary-light,
      $primary-dark,
    ),
    "link": (
      $link,
      $link-invert,
      $link-light,
      $link-dark,
    ),
    "info": (
      $info,
      $info-invert,
      $info-light,
      $info-dark,
    ),
    "success": (
      $success,
      $success-invert,
      $success-light,
      $success-dark,
    ),
    "warning": (
      $warning,
      $warning-invert,
      $warning-light,
      $warning-dark,
    ),
    "danger": (
      $danger,
      $danger-invert,
      $danger-light,
      $danger-dark,
    ),
    "gold": (
      $gold,
      $gold-invert,
      $gold-light,
      $gold-dark,
    ),
    "grey": (
      $grey,
      $grey-invert,
      $grey-light,
      $grey-dark,
    ),
    "grey-1": (
      $grey-1,
      $grey-1-invert,
      $grey-1-light,
      $grey-1-dark,
    ),
    "grey-2": (
      $grey-2,
      $grey-2-invert,
      $grey-2-light,
      $grey-2-dark,
    ),
  ),
  $custom-colors
);

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

// Import Vue2-Editor
@import "~vue2-editor/dist/vue2-editor.css";

html {
  overflow-y: hidden !important;
}
</style>
